import { useEffect } from 'react';
import { useUserRewardStore } from 'lib/store/userRewardStore';

export default function RewardsActivityIds({ data }) {
  const { activityIds } = data;
  const { appendLotteryActIdList } = useUserRewardStore((state) => state);

  useEffect(() => {
    if (!activityIds) return;
    // 过滤掉空字符串
    const list = activityIds
      .split(',')
      .map((id) => parseInt(id, 10))
      .filter((id) => !!id);
    appendLotteryActIdList(list);
  }, [activityIds]);

  return null;
}
